import { Skeleton } from 'antd';

const Loader = () => (
  <div className="small-container">
    <Skeleton active />
  </div>
);

export default Loader;
